export const initialState = {
    is_loading: false,
    show: false,
    job_id: null,
    job_details: {},
    is_show_remedial_job_details: false,
    request_status: ""
}